export function makeGlossaryItemId(id: string) {
  return `glossary-item-${id}`;
}

export function makeGlossaryItemDefinitionId(id: string) {
  return `glossary-item-definition-${id}`;
}
